/**
 * ScreenHead — a tab's title, how many there are, and the flag under them. Task 66.
 *
 * The headline of a bill (`docs/superpowers/specs/2026-10-25-oblik-afisha-design.md` «Общие
 * части»): the title large and gold, the count at its right in grey — «60 треков», «4 ролика» —
 * and the flag across the whole width. The four tabs draw it the same way; a list opened inside
 * «Треки» has a head of its own.
 *
 * Task 69: a list opened inside «Треки» — an artist, a riddim, a tag — draws the same head under
 * «← Назад», with a line under the title that says what it is: «Исполнитель · 6 треков».
 *
 * A count the screen does not know yet is not drawn at all — no «…», no zero. It comes with the
 * first page of the list (`total`, `apps/api/src/routes/catalogue.ts`), and the title does not
 * move when it does: the count sits at the right on the title's baseline.
 */

import type { JSX } from 'react';

export function ScreenHead({
  title,
  count,
  meta,
}: {
  readonly title: string;
  readonly count?: string | undefined;
  /** Task 69: the line under the title of an opened list. */
  readonly meta?: string | undefined;
}): JSX.Element {
  return (
    <>
      <div className="screenHead">
        <h1 className="screenTitle">{title}</h1>
        {count !== undefined && <span className="screenCount">{count}</span>}
      </div>
      {meta !== undefined && <p className="screenMeta">{meta}</p>}
      <div className="flagStripe" aria-hidden="true" />
    </>
  );
}
